import { Observable } from "rxjs";
import { Profile } from "../models/profile";
import { httpClient } from "../shop/shop-context";
import { map } from "rxjs/operators";

export class ProfileService{
    private _url = 'connect/profile';
	getById(profileId: number): Observable<Profile> {
		const url = `/${this._url}/${profileId}`;

		return httpClient.get(url)
			.pipe(map((profile: Profile) => profile));
	}
}